import styled from "styled-components";

export const WrapperContent = styled.div`
  width: 100%;
  padding: 0 24px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const WrapperSubtitles = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;


export const Title = styled.h2`
  font-family: 'Spartan-ExtraBold';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  color: #c6016b;
  letter-spacing: -0.05em;
  margin-left: 24px;
  margin: 8px 0;
  text-align: center;
  line-height: 1;
`

export const DescriptionText = styled.span`
  font-family: 'Lato-Regular';
  font-size: 10px;
  letter-spacing: -0.05em;
  margin-bottom: 4px;
  text-align: justify;
  line-height: 1.1;
`;

export const Subtitle = styled.span`
  font-family: 'Spartan-SemiBold';
  letter-spacing: -0.05em;
  color: #2d749c;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
  text-align: left;
  margin-bottom: 4px;
`;
